import React, {Fragment} from 'react';
import {compose} from 'redux';
import {translate} from 'react-i18next';
import LoaderCsvForm from './csv-form';
import LoaderXmlForm from './xml-form';
import {Divider, Radio} from 'antd';
import {connect} from 'react-redux';
import {DataLanguageConsumer} from "../../../contexts/DataLanguage";
import {setLoaderFormat} from "./actions";

const mapStateToProps = state => ({
  format: state.scenes.dataManager.loader.shared.format
});

const mapDispatchToProps = dispatch => ({
  setFormat: format => dispatch(setLoaderFormat(format))
});

const Loader = ({
                  format,
                  setFormat
                }) =>
  <Fragment>
    <Radio.Group
      defaultValue="csv"
      onChange={({target}) => setFormat(target.value)}
    >
      <Radio.Button value="csv">
        CSV
      </Radio.Button>
      <Radio.Button value="sdmx-ml">
        SDMX-ML
      </Radio.Button>
      <Radio.Button value="xls">
        Excel
      </Radio.Button>
      <Radio.Button value="px">
        PC-Axis
      </Radio.Button>
    </Radio.Group>
    <Divider/>
    {(format === 'csv' || format === 'xls' || format === 'px') && <LoaderCsvForm/>}
    {format === 'sdmx-ml' && (
      <DataLanguageConsumer>
        {dataLanguage => <LoaderXmlForm dataLanguage={dataLanguage}/>}
      </DataLanguageConsumer>
    )}
  </Fragment>;

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(Loader);



// WEBPACK FOOTER //
// ./src/scenes/data-manager/loader/index.jsx